module.exports = "/img/_/_/_/assets/images//card.png?63c3667d4e12e5c5fe930278558e919b";